import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, model, signal, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentLanguage, SessionStorageService } from 'src/app/services';
import { CheckRouteByEmail } from './services';

@Component({
  selector: 'app-qr-view',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './qr-view.component.html',
  styleUrls: ['./qr-view.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QrViewComponent  {
  public qrRef = viewChild('qrRef');
  
  protected email = model<string | undefined>(undefined);
  
  private _currentLanguageService = inject(CurrentLanguage);
  private _checkRouteByEmailService = inject(CheckRouteByEmail);
  private _sessionStorageService = inject(SessionStorageService);
  
  protected currentLang = this._currentLanguageService.currentLang;
  
  protected isSendEmailView = signal<boolean>(false);
  
  constructor() {
    this._sessionStorageService.removeAll();
  }

  protected onEmailInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement) return;
  
    const email = inputElement.value;
    this.email.set(email);
  }
  
  protected onSendEmailClick() {
    this.isSendEmailView.update(value => !value);
  }
  
  protected onSubmit() {
    const email = this.email();
    if (!email) return;
    
    this._checkRouteByEmailService.checkRouteByEmail(email);
  }
}
